let filters = document.querySelector('.filter-holder');
let filtersOpen = document.querySelector('.js-open-filters');
let filtersClose = document.querySelectorAll('.js-close-filters');
let toggleFilters = document.querySelectorAll('legend');
let filtersGroupTitle = document.getElementsByClassName('js-filter-group');

for (i = 0; i < filtersGroupTitle.length; i++) {
    filtersGroupTitle[i].addEventListener('click', function (e) {
        e.preventDefault();
        this.classList.toggle('open');
        var panel = this.nextElementSibling;
        if (panel.style.display === '' || panel.style.display === 'none') {
            panel.style.display = 'block';
        } else {
            panel.style.display = 'none';
        }
    });
}

for (let i = 0; i < toggleFilters.length; i++) {
    toggleFilters[i].addEventListener('click', function () {
        this.parentNode.classList.toggle('open');
    });
}

filtersOpen.addEventListener('click', openFilters);

for (let i = 0; i < filtersClose.length; i++) {
    filtersClose[i].addEventListener('click', closeFilters);
}

function openFilters() {
    filters.classList.add('open');
    document.body.classList.add('filters-open');
}

function closeFilters() {
    filters.classList.remove('open');
    document.body.classList.remove('filters-open');
}

//Function to get the elements position outside of his parent.
function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
        top: rect.top + window.scrollY
    };
}

//Set filter button fixed when reaches top of the screen
var stickyButton = getOffset(filtersOpen).top;

function fixedFilterButton() {
    if ((window.pageYOffset + 20) > stickyButton) {
        filtersOpen.classList.add('is-sticky');
    } else {
        filtersOpen.classList.remove('is-sticky');
    }
}

window.onscroll = function () {
    fixedFilterButton();
};

//Set filter button stuck at bottom of vacancy block when user scrolls to the bottom of the block
const button = document.getElementById('offsetButton');
const content = document.querySelector('.block_vacancy_overview');
const contentRect = content.getBoundingClientRect();
const contentOffset = contentRect.bottom;

window.addEventListener('scroll', () => {
    //Only set the button to stuck if the content is bigger than the window height
    if (contentOffset <= (window.pageYOffset + window.innerHeight) && contentRect.height > window.innerHeight) {
        const offset = contentRect.height - 98;
        button.style.transform = `translateY(${offset}px)`;
        button.classList.add('stuck');
    } else {
        button.style.transform = '';
        button.classList.remove('stuck');
    }
});

//Reset search query
const resetSearchButton = document.querySelector('.js-reset-search');
const searchForm = document.getElementById('mse2_form');

if (resetSearchButton) {
    resetSearchButton.addEventListener('click', () => {
        searchForm.submit();
    });
}
